var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"pt-3",staticStyle:{"padding-bottom":"5rem"}},[_c('h2',[_vm._v("Todo")]),_c('b-list-group',_vm._l((_vm.$store.state.settings.dclasses),function(dclass){return _c('div',{key:dclass.hcname},[_c('b-list-group-item',{style:({
          backgroundColor: _vm.chroma(dclass.color.hex || dclass.color)
            .desaturate(2)
            .alpha(0.4)
            .hex(),
        }),attrs:{"variant":"none"}},[_vm._v(_vm._s(dclass.name)+" "),_c('b-icon-plus-circle',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"bi-type-bold float-right mt-1",staticStyle:{"cursor":"pointer"},attrs:{"title":"Add new","scale":"1.2"},on:{"click":function () { return _vm.$store.dispatch('promptCreateNewAssignment', dclass.hcname); }}})],1),_vm._l((dclass.assignments),function(asg,idx){return _c('todo-item',{key:'todo' + idx,attrs:{"completed":false,"item":{
          hcname: dclass.hcname,
          title: asg.title,
          dueDate: asg.dueDate,
          color: dclass.color.hex || dclass.color,
          type: asg.type,
        }}})}),_vm._l((dclass.completed),function(asg,idx){return _c('todo-item',{key:'completed-' + idx,attrs:{"completed":true,"item":{
          hcname: dclass.hcname,
          title: asg.title,
          dueDate: asg.dueDate,
          color: dclass.color.hex || dclass.color,
          type: asg.type,
        }}})})],2)}),0)],1)}
var staticRenderFns = []

export { render, staticRenderFns }